import { AnimatePresence, motion } from 'framer-motion'
import { FileEdit, FilePlus, X } from 'lucide-react'
import React, { useEffect, useState } from 'react'
import PatientNoteViewInModal from './PatientNoteViewInModal'
import SaveExtra from '../../services/general/saveExtraData.api'
import ProviderPatientNoteViewInModal from './ProviderPatientNoteViewInModal'
import ProviderLsPatientNoteView from './ProviderLsPatientNoteView'
import { useIndexedDB } from '../../context/IndexedContext'

const FloatingNotePreview = ({
  peAdded,
  setPEAdded,
  submitNotes,
  setDataId,
  statusPatientNote,
  showMedicationLikeApp,
  showHrsInTreatment,
  showTreatmentAsAccordion,
  setModalVisible,
  formData,
  diagnosis,
  allLabs,
  patientID,
  diagnosisCode,
  selectedRisks,
  setSelectedRisks,
  MasterDiagnosisData,
  noteStructureRef,
  newmedsAdded,
  newLabsAdded,
  newImagingAdded,
  patientData,
  patientTreatments,
  hospitalRecords,
  patientDiagnosis,
  diagnosisAddedPinger,
  setHospitalRecords,
  patientSidebarActiveTab,
  allergies,
  setAllergies,
  personalHistory,
  setPersonalHistory,
  medication,
  setMedication,
  imaging,
  setImaging,
  activeTab,
  imagingTypeList,
  selectedDifferentialDiagnosis,
  hpiAdded,
  setHpiAdded,
  addedNewIncident,
  setAddedNewIncident,
  rosAdded,
  setRosAdded,
  noteID,
  patientDBData,
  changesInTreatmentShell,
  setChangesInTreatmentShell,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const showDataIfNoteIsFollowUp = statusPatientNote && statusPatientNote === 'Follow Up' ? true : false
  const [addendum, setAddendum] = useState([])
  const { getAddedEndumen } = useIndexedDB()

  const fetchAddendumData = async () => {
    try {
      // let data = await SaveExtra('Get_By_Type', 'Addendum', '', '')
      // data = JSON.parse(data?.d)?.Data || []
      let data = await getAddedEndumen()

      data = data.map((item) => JSON.parse(item?.JsonData))

      data = data.reverse() // latest first

      const currentNoteID = noteID?.toString()
      const noteIDNum = parseInt(noteID, 10)

      const previousNoteID = noteIDNum > 0 ? (noteIDNum - 1).toString() : null

      const findPatientNoteData = (data, patientID, noteID) => {
        for (let i = 0; i < data.length; i++) {
          const item = data[i]

          if (item[patientID]) {
            if (item[patientID][currentNoteID]) {
              return item[patientID][currentNoteID]
            }

            // if (previousNoteID && item[patientID][previousNoteID]) {
            //     return item[patientID][previousNoteID];
            // }
          }
        }
        return null
      }

      const result = findPatientNoteData(data, patientID, noteID)

      if (result) {
        setAddendum(result)
      } else {
        const searchNotes = noteIDNum > 0 ? `${noteID} or ${noteIDNum - 1}` : noteID
        console.warn(`Patient ${patientID} with note ${searchNotes} not found`)
        setAddendum(null)
      }
    } catch (error) {
      console.error('Failed to fetch addendum data:', error)
      setAddendum(null)
    }
  }

  useEffect(() => {
    fetchAddendumData()
  }, [])

  return (
    <div>
      <AnimatePresence>
        {!isOpen && (
          <motion.span
            // close the modal when isopen is true
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.5 }}
            transition={{ duration: 0.3 }}
            className="translate-y-haklf"
            onClick={() => setIsOpen(!isOpen)}
            style={{
              position: 'absolute',
              right: 20,
              top: '50%',
              // backgroundColor: '#4363F2',
              color: 'white',
              padding: '10px',
              borderRadius: '50%',
              zIndex: 120102102,
            }}
          >
            <FileEdit strokeWidth={1.5} size={20} />
          </motion.span>
        )}
      </AnimatePresence>
      {/* add animatepresence motion framer */}
      <AnimatePresence>
        <motion.div initial={{ opacity: 0, scale: 0.5 }} animate={{ opacity: isOpen ? 1 : 0, scale: isOpen ? 1 : 0.5 }} exit={{ opacity: 0, scale: 0.5 }} transition={{ duration: 0.3 }} style={{ display: isOpen ? 'block' : 'none', zIndex: 100000 }} key="floating-note-preview">
          {/* shpw floating div right top relative to button */}
          <div
            style={{
              position: 'fixed',
              top: '42%',
              right: '30px',
              transform: 'translateY(-30%)',
              width: '800px',
              backgroundColor: '#f9f9f9',
              maxHeight: '600px',

              // borderRadius: '8px',
              backgroundColor: 'white',
              overflowY: 'auto',
              zIndex: 120102102,
            }}
            className="show-note-preview-direct"
          >
            <div
              style={{
                backgroundColor: '#1E1E1E',
                border: '1px solid #ccc',
                color: 'white',
              }}
              className="d-flex align-items-center justify-content-end p-3 "
            >
              <X size={20} onClick={() => setIsOpen(false)} />
            </div>
            <ProviderLsPatientNoteView
              hpiAdded={hpiAdded}
              setHpiAdded={setHpiAdded}
              peAdded={peAdded}
              setPEAdded={setPEAdded}
              onlyShowHTmlService={false}
              setDataId={setDataId}
              showDataIfNoteIsFollowUp={showDataIfNoteIsFollowUp}
              showTreatmentAsAccordion={showTreatmentAsAccordion}
              showHrsInTreatment={showHrsInTreatment}
              showMedicationLikeApp={showMedicationLikeApp}
              diagnosisCode={diagnosisCode}
              noteStructureRef={noteStructureRef}
              selectedRisks={selectedRisks}
              setSelectedRisks={setSelectedRisks}
              selectedDifferentialDiagnosis={selectedDifferentialDiagnosis}
              hospitalRecords={hospitalRecords}
              setHospitalRecords={setHospitalRecords}
              medication={medication}
              setMedication={setMedication}
              patientID={patientID}
              patientTreatments={patientTreatments}
              newImagingAdded={newImagingAdded}
              newLabsAdded={newLabsAdded}
              newmedsAdded={newmedsAdded}
              diagnosisAddedPinger={diagnosisAddedPinger}
              allergies={allergies}
              setAllergies={setAllergies}
              patientDiagnosis={patientDiagnosis}
              rosAdded={rosAdded}
              setRosAdded={setRosAdded}
              addedNewIncident={addedNewIncident}
              setAddedNewIncident={setAddedNewIncident}
              MasterDiagnosisData={MasterDiagnosisData}
              imagingTypeList={imagingTypeList}
              imaging={imaging}
              setImaging={setImaging}
              activeTab={activeTab}
              patientData={patientData}
              patientSidebarActiveTab={patientSidebarActiveTab}
              personalHistory={personalHistory}
              setPersonalHistory={setPersonalHistory}
              allLabs={allLabs}
              noteShow={false}
              noteID={noteID}
              addendumData={addendum}
              patientDBData={patientDBData}
              changesInTreatmentShell={changesInTreatmentShell}
              setChangesInTreatmentShell={setChangesInTreatmentShell}
            />
          </div>
        </motion.div>
      </AnimatePresence>
    </div>
  )
}

export default FloatingNotePreview
